export const DISAPPEAR = 'disappear_H5' // 销毁协议地址
export const PRIVACY_AGREEMENT = 'privacy_agreement_H5' // 隐私政策地址
export const USER_AGREEMENT = 'user_agreement_H5'; // 用户协议地址


export const STORAGE_KEY = 'token' //登录
export const INFO = 'info' //用户信息
export const ENVIRONMENT = 'environment' //环境
export const LOGIN_TIME = 'login_time' //登录时间

export const signpop = "signpop" //签到
export const IOSPAR = "iosPar" //ios 控制启动按钮的显示隐藏
export const PRIVACY = 'has_read_privacy' // 同意用户协议
export const DEVICEID = 'deviceId' // 设备唯一激活标记 获取客户端返回的

// export const DISAPPEAR = 'disappear' // 销毁协议地址
// export const PRIVACY_AGREEMENT = 'privacy_agreement' // 隐私政策地址
// export const USER_AGREEMENT = 'user_agreement'; // 用户协议地址

export const Teen_KEY = 'teenpopupDate' //
export const Teenpopuate = 'teenpopuate' //  用户设置青少年模式密码
export const WorkbenchKey = 'workbenchKey' // 引导页记录key

export const Community_GUIDE = 'communityguide' // 社区初始化
export const CommunityKey = 'communityKey' // 社区搜索历史记录key
export const Lookimgpop = 'lookimgpop' // 查看图片预览引导
export const Loovideopop = 'lookvideopop' // 查看视频预览引导

export const TABBAR_KEY = 'tabbarkey' // tabbar

export const CLOUD_DEVICE_AGREEMENT = 'cloud_device_agreement' // 云挂机用户协议
export const DISCOUNT_SHOP_PAY_AGREEMENT = 'discountShop_pay_agreement' // 特惠充值勾选

export const CLOUD_LAYOUT = 'cloudlayout' // 云挂机布局
export const CLOUD_QUN_CONTROL = 'cloudQunControl' // 云挂机群控状态
export const CLOUD_GROUP_CONTROL_DEVICES = 'cloudGroupControlDevices' // 云挂机群控设备

export const CLOUD_AD = 'cloud_device_ad' // 云挂机广告
export const GAME_FLAG = 'gameFlag'// 提审ios 游戏按钮展示下载还是获取
